import { Component, SimpleChanges, Input } from '@angular/core';
import { ComponentBase } from '@framework/base/component';

@Component({
  selector: 'gs-skeleton-loader',
  templateUrl: './gs-skeleton-loader.component.html',
  styleUrls: ['./gs-skeleton-loader.component.css']
})
export class GsSkeletonLoaderComponent extends ComponentBase {
  // Input data
  @Input() count: number = 1;
  @Input() appearance: string = 'line';
  @Input() theme: any;
  @Input() width: number | string;
  @Input() height: number | string;
  @Input() fromVideo: boolean = false;
  @Input() videoStatusText: any = 'Uploading';
  @Input() borderRadius: string = '4px';
  @Input() animation: string = 'pulse';
  
  // Private variables

  // Public variables

  constructor() {
    super();
  }

  // Life cyle hooks
  protected onInit(): void {
    this.initializeTheme();
  }
  
  protected onDestroy(): void {

  }
  
  protected onChanges(changes: SimpleChanges): void {
    this.initializeTheme();
  }
  
  protected onDoCheck(): void {

  }
  
  protected onAfterContentInit(): void {

  }
  
  protected onAfterContentChecked(): void {

  }
  
  protected onAfterViewInit(): void {

  }
  
  protected onAfterViewChecked(): void {

  }

  // Private functions
  public initializeTheme(): void {
    this.theme = this.theme || {};
    
    // Handle width
    if (this.width) {
      this.theme.width = typeof +this.width === 'number' ? `${this.width}px` : this.width;
    }
    
    // Handle height
    if (this.height) {
      this.theme.height = typeof +this.height === 'number' ? `${this.height}px` : this.height;
    }
    
    // Set border radius
    this.theme.borderRadius = this.borderRadius;
    
    // Set animation
    this.theme.animation = this.animation;
    
    // Set video status text
    this.videoStatusText = this.videoStatusText;
  }

  // Public functions

}
